<template>
  <div class="" style="padding-left: 3%; padding-right: 3%; background-color: #F8F9FA;">
    <v-row class="mb-2">
      <v-col cols="6">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0">
          แก้ไขสิทธิ์การใช้งานเครือบริษัท
        </span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn">
        <v-btn width="18%" class="button-color-outline ma-0" outlined dark @click="goBack()">ยกเลิก</v-btn>
        <!-- <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="submitData()">บันทึกข้อมูล</v-btn> -->
        <v-btn width="18%" class="button-color ma-2 mr-2" dark @click="dialogConfirm = true">บันทึกข้อมูล</v-btn>
      </v-col>
    </v-row>
    <div style="background-color: #fff; max-height: auto;" class="pt-1">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <!-- <v-row :class="$vuetify.breakpoint.name !== 'lg'? 'pt-3':'pt-3 px-16'">
          <v-col cols="4" sm="6" md="2" lg="2" class="pb-0">
            <p class="txt-font">ชื่อเครือ</p>
          </v-col>
          <v-col cols="8" sm="5" md="5" lg="5" class="pb-0">
            <v-select
              v-model="selectGroupCompany"
              :items="itemGroupCompany"
              item-text="nameEng"
              item-value="id"
              :rules="inputRules"
              outlined
              dense
              placeholder="เลือกเครือ"
            />
          </v-col>
        </v-row> -->
        <!-- v-if="this.$route.params.title === 'เครือ'" -->
      <!-- v-if="this.$route.params.title === 'บริษัท'" -->
      <v-row class="" justify="center">
        <v-col cols="8" class="mt-3" style="background-color: #FAFAFA; height: 80px;">
          <v-row class="px-12">
            <v-col cols="9" sm="12" md="9" lg="9">
              <div
                class="pt-0 d-flex flex-row align-center justify-end"
                color="grey lighten-2"
                flat
                tile
              >
              <span class="ra-span-text-highlight mb-4 mr-2">เครือบริษัท : </span>
                <v-select
                  v-model="selectGroupCompany"
                  :items="itemGroupCompany"
                  item-text="groupCompanyNameTh"
                  item-value="_id"
                  :rules="inputRules"
                  @change="getSelectorGroup()"
                  outlined
                  dense
                  placeholder="เลือกเครือ"
                />
                <v-tooltip bottom>
                  <span class="label-table-action">ค้นหาพนักงาน</span>
                </v-tooltip>
              </div>
            </v-col>
            <v-col cols="2" sm="12" md="6" lg="2" xl="2" class="pb-0 align-end">
              <v-btn
                  outlined
                  class="ra-button1 pa-3 rounded-lg"
                  color=""
                  dark
                  style="background-color: #EFF4FD; margin-top: 0%;"
                  @click="add()"
                  :disabled="selectGroupCompany === ''"
                >
                <v-icon left dark color="#3776E9" size="14px">mdi-plus</v-icon>
                <span class="ra-text-in-button-editRoleGroup" style="color: #3776E9;">
                  เพิ่มสิทธิ์การใช้งาน
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <OverlayLoading :loading="loading" />
      <v-col cols="8" class="mx-auto px-0 mb-5">
        <div v-for="(input,k) in detailRole" :key="k">
          <v-card
            class="mx-auto px-0 mb-5"
          >
            <v-row style="background-color: #EFF4FD" class="pa-0 ma-0">
              <v-col cols="10">
                <v-col cols="10" class="pt-0 pa-0 d-flex flex-row justify-start">
                <span class="txt-head">ลำดับที่ {{ k+1 }}<span class="ml-1"></span><span class="txt-font" style="color: grey; font-size: 14px;">&nbsp;(</span><span style="color: red;">*</span><span class="txt-font" style="color: grey; font-size: 14px;">กรอกข้อมูลให้ครบถ้วน)</span></span>
                </v-col>
              </v-col>
              <v-col v-if="detailRole.length > 1" cols="2" class="pt-2 pa-2 d-flex flex-row align-center justify-end">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      dark
                      icon
                      tile
                      class="ra-border-button mr-2"
                      @click="checkRemove(k)" v-show="k || ( !k && detailRole.length > 1)">
                      <template v-slot>
                        <v-icon dark color="#D1392B" size="19px">mdi-delete-outline</v-icon>
                      </template>
                    </v-btn>
                  </template>
                  <span class="label-table-action">ลบข้อมูล</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row class="pa-5">
              <v-col cols="6" class="form-control" style="margin-top: 0%;">
                <span class="txt-font">ชื่อสิทธิ์การใช้งาน</span>
                <v-select
                  v-model="detailRole[k].roleName"
                  :items="itemRoleType"
                  item-text="name"
                  item-value="_id"
                  @change="filterDetail(detailRole[k].roleName, k), changeColor(detailRole[k].roleName, k)"
                  :rules="inputRules"
                  outlined
                  label="เลือกชื่อสิทธิ์การใช้งาน"
                  dense
                ></v-select>
              </v-col>
              <v-col cols="6" class="form-control">
                <span class="txt-font">ประเภทสิทธิ์การใช้งาน</span>
                <v-text-field
                  v-model="detailRole[k].roleType"
                  label="ประเภทสิทธิ์การใช้งาน"
                  readonly
                  solo
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="6" class="form-control">
                <span class="txt-font">รายละเอียดสิทธิ์การใช้งาน</span>
                <v-textarea
                  v-model="detailRole[k].description"
                  label="รายละเอียดสิทธิ์การใช้งาน"
                  readonly
                  disabled
                  solo
                  dense
                  height="20"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-col>
    </v-form>
    </div>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" outlined @click="dialogDelete = false">ยกเลิก</v-btn>
          <v-btn class="button-color" dark @click="remove(itemConfirmDelete)">ลบข้อมูล</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirm" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5">ต้องการบันทึกข้อมูลนี้ ใช่หรือไม่?</v-card-title>
        <v-card-text class="justify-center text-center">
        <span class="ra-head-text justify-center">คุณแน่ใจหรือว่าต้องการบันทึกข้อมูลนี้</span>
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn class="button-color-outline" outlined @click="dialogConfirm = false">ยกเลิก</v-btn>
          <v-btn class="button-color" dark @click="submitData()">ยืนยัน</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        text
        top
        app
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
      </v-row>
    </div>
  </div>
</template>

<script>
import {
  getlistRoleGroupById,
  getSelectorGroup,
  getListCompanyByGroupCompanyEngName,
  getCompanySelector,
  getSelectRoleCompany,
  getChartPickerSelector,
  updateRoleGroupCompany
} from '@/API/API'
import { OverlayLoading } from '@/components/index'
import swal from 'sweetalert'

export default {
  name: 'create-new-department',
  components: {
    OverlayLoading
  },
  data () {
    return {
      // colorLock: 'red',
      dialogConfirm: false,
      multiLine: true,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      tokenUser: '',
      loading: false,
      detailRole: [],
      selectType: '',
      selectOrgChart: '',
      itemOrgChart: [],
      selectGroupCompany: '',
      selectCompany: '',
      selectLine: [],
      selectDepartment: [],
      selectDivision: [],
      selectAgency: [],
      selectWorkgroup: [],
      itemGroupCompany: [],
      itemCompany: [],
      itemLine: [],
      itemDepartment: [],
      itemDivision: [],
      itemAgency: [],
      itemWorkgroup: [],
      itemRoleType: [],
      roleCompanyList: [],
      chartPickerSelector: [],
      valid: true,
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      TypeName: [
        'ทั้งหมด',
        'สายงาน',
        'ฝ่ายงาน',
        'ส่วนงาน',
        'หน่วยงาน',
        'กลุ่มงาน'
      ]
    }
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    // if (!this.$route.params.id) this.$router.go(-1)
    // if (this.$route.params.id) {
    //   this.propsRoleId = this.$route.params.id
    // }
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      this.getlistRoleGroupById(this.$route.params.id)
    }
    this.getSelectorGroup()
    this.getCompanyList()
    this.getRoleCompanyList()
  },
  computed: {
    checkCompany () { return !!this.selectGroupCompany.length }
  },
  watch: {
    // detailRole: {
    //   handler: function (after, before) {
    //     // Return the object that changed
    //     var changed = after.filter(function (p, idx) {
    //       console.log('value', p)
    //       if (p.roleName !== '') {
    //         console.log('Value If', p.roleName)
    //         console.log('Color', p.colorLock)
    //         p[idx].colorLock = 'success'
    //         // this.colorLock = 'red'
    //       }
    //       // return Object.keys(p).some(function (prop) {
    //       //   return p[prop] !== before[idx][prop]
    //       // })
    //     })
    //   },
    //   deep: true
    // selectGroupCompany () {
    //   this.itemCompany = this.allCompany.result.filter(e => e.level === 'ชื่อบริษัท' && this.selectGroupCompany === e.pId)
    // },
    // selectCompany () {
    //   this.selectType = ''
    // },
    // async selectType () {
    //   await this.getChartSelector()
    // }
  },
  methods: {
    goBack () {
      this.$router.go(-1)
    },
    changeColor (val, index) {
      if (val !== '') {
        this.detailRole[index].colorLock = 'success'
      }
    },
    filterDetail (val, i) {
      this.detailRole[i].roleType = []
      this.detailRole[i].description = []
      var filterValue = this.roleCompanyList.filter(r => {
        if (r._id === val) {
          return r
        }
      })
      this.detailRole[i].roleType = filterValue[0].type.typeName
      this.detailRole[i].description = filterValue[0].comment
    },
    async getlistRoleGroupById () {
      // const tempTest = []
      // const temp = []
      const obj = {
        groupId: this.$route.params.id
      }
      try {
        const res = await getlistRoleGroupById(obj, this.tokenUser)
        if (res.success) {
          if (res.result.groupId === null) {
            this.selectGroupCompany = ''
          } else {
            this.selectGroupCompany = res.result.groupId
          }
          // this.selectCompany = res.result[0].companyId
          // this.selectType = res.result[0].orgChartType
          // this.selectOrgChart = res.result[0].orgChartId
          // this.editId = res.result[0]._id
          for (let index = 0; index < res.result.permissionDetail.length; index++) {
            this.detailRole.push({
              roleName: res.result.permissionDetail[index]._id,
              // roleName: '60af1f80d456a54570c7c788',
              roleType: res.result.permissionDetail[index].typeName,
              description: res.result.permissionDetail[index].comment,
              colorLock: 'success'
            })
          }
          this.loading = false
        } else {
          // console.log(res)
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getChartSelector () {
      this.loading = true
      const payload = {
        orgChartType: this.selectType,
        companyId: this.selectCompany
      }
      try {
        const res = await getChartPickerSelector(this.tokenUser, payload)
        // console.log('res get chart', res)
        if (res.success) {
          this.chartPickerSelector = res
          this.selectOrgChart = ''
          this.itemOrgChart = this.chartPickerSelector.result
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCompanySelector () {
      this.loading = true
      try {
        const res = await getCompanySelector(this.tokenUser)
        // console.log('res g', res)
        if (res.success) {
          this.allCompany = res
          // this.itemGroupCompany = this.allCompany.result.filter(e => e.level === 'ชื่อเครือ')
          this.itemGroupCompany = res.result
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getRoleCompanyList () {
      this.loading = true
      try {
        const res = await getSelectRoleCompany(this.tokenUser)
        if (res.success) {
          this.roleCompanyList = res.result
          for (let index = 0; index < this.roleCompanyList.length; index++) {
            this.itemRoleType.push({
              name: this.roleCompanyList[index].name,
              _id: this.roleCompanyList[index]._id
            })
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getSelectorGroup () {
      this.loading = true
      // var temp = []
      const obj = {
        groupCompanyId: this.selectGroupCompany,
        companyId: this.selectCompany,
        section: this.TypeName.indexOf(this.selectType)
      }
      // console.log('เครือ: ', obj)
      try {
        const res = await getSelectorGroup(this.tokenUser, obj)
        if (res.success) {
          // console.log('company: ', res.result)
          // res.result.map(el => {
          //   temp.push({
          //     id: el._id,
          //     name: el.companyShortNameEng
          //   })
          // })
          this.itemCompany = res.company
          this.itemGroupCompany = res.groupCompany
          this.itemOrgChart = res.orgChart
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    async getCompanyList () {
      this.loading = true
      var temp = []
      const obj = {
        groupCompanyList: this.selectGroupCompany
      }
      // console.log('เครือ: ', obj)
      try {
        const res = await getListCompanyByGroupCompanyEngName(this.tokenUser, obj)
        // console.log('group: ', res)
        if (res.success) {
          // console.log('company: ', res.result)
          res.result.map(el => {
            temp.push({
              id: el._id,
              name: el.companyShortNameEng
            })
          })
          this.itemCompany = temp
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    pressSelectAll (objectname) {
      this.$nextTick(() => {
        if (this[`select${objectname}`].length === this[`item${objectname}`].length) {
          this[`select${objectname}`] = []
        } else {
          this[`select${objectname}`] = [...new Set(this[`item${objectname}`].map(x => x.id))]
        }
      })
    },
    add () {
      this.detailRole.push({
        roleName: '',
        roleType: '',
        description: '',
        colorLock: 'warning'
      })
      this.text = 'เพิ่มสิทธิ์การใช้งาน'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    checkRemove (item) {
      this.dialogDelete = true
      this.itemConfirmDelete = item
    },
    remove (index) {
      this.detailRole.splice(index, 1)
      this.itemConfirmDelete = []
      this.dialogDelete = false
      this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    submitDataTest () {
      const obj = {
        groupId: this.selectGroupCompany,
        companyId: this.selectCompany,
        orgChartid: this.selectOrgChart,
        section: this.TypeName.indexOf(this.selectType) + 1,
        permission: this.detailRole
      }
      console.log('obj data', obj)
    },
    async submitData () {
      this.dialogConfirm = false
      var duplicate = []
      var permissionList = []
      for (let index = 0; index < this.detailRole.length; index++) {
        permissionList.push(this.detailRole[index].roleName)
      }
      const obj = {
        groupId: this.selectGroupCompany,
        // companyId: this.selectCompany,
        // chartId: this.selectOrgChart,
        permission: permissionList
        // groupId: this.selectGroupCompany,
        // companyId: this.selectCompany,
        // orgChartid: this.selectOrgChart,
        // section: this.TypeName.indexOf(this.selectType) + 1,
        // permission: this.detailRole
      }
      var filterValue = this.detailRole.filter(r => {
        if (r.roleName === '') {
          this.$refs.form.validate()
          return r
        }
      })
      for (let index = 0; index < this.detailRole.length; index++) {
        duplicate.push(this.detailRole[index].roleName)
      }
      var findDuplicates = arr => arr.filter((item, index) => arr.indexOf(item) !== index)
      var allDup = [...new Set(findDuplicates(duplicate))]
      if (this.selectGroupCompany === '' || filterValue.length !== 0) {
        this.$refs.form.validate()
        swal('คำเตือน', 'กรุณากรอกข้อมูลให้ครบ', 'warning')
      } else {
        if (allDup.length > 0) {
          swal('คำเตือน', 'มีข้อมูลชื่อ Role ซ้ำกัน', 'warning')
        } else {
          try {
            const res = await updateRoleGroupCompany(obj, this.tokenUser)
            if (res.success) {
              swal('สำเร็จ', 'กำหนดสิทธิ์การใช้งานสำเร็จ', 'success', {
                button: false,
                timer: 2000
              })
              this.loading = false
              this.$router.go(-1)
            } else {
              swal('ผิดพลาด', `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`, 'error', {
                button: false,
                timer: 2000
              })
            }
          } catch (error) {
            console.log(error)
            swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
              button: false,
              timer: 2000
            })
          } finally {
            this.loading = false
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.round1 {
  border: 1px solid rgb(165, 163, 163);
  border-radius: 5px;
}
.right {
  margin: auto;
  width: 60%;
  border: 3px solid #73AD21;
  padding: 10px;
}
.head-expand {
  background-color: #C5E1A5 ;
}
.box-tooltip {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  width: 20vw;
  height: 12vh;
  font-family: 'Open Sans';
}
.ra-text-in-button-editRoleGroup {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
}
</style>
